import { useMemo, useState } from 'react';

import type { Option } from './types';

const useSelectMenu = ({
  options,
  onChange,
  value
}: {
  options: Option[];
  onChange: (userSetting: Option) => void;
  value: string | null;
}) => {
  const [open, setOpen] = useState(false);

  const handleMenuItemClick = (index: number) => {
    onChange(options[index]);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const selected = useMemo(() => {
    return options.find(option => option.value === value) || null;
  }, [options, value]);

  return {
    open,
    handleMenuItemClick,
    handleOpen,
    handleClose,
    selected
  };
};

export default useSelectMenu;
